import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@/components/primitives/Button.jsx';
import Input from '@/components/primitives/Input.jsx';
import Dialog from '@/components/patterns/Dialog.jsx';
import toastManager from '@/lib/toast/toastManager.js';
import createOrganization from '@/redux/actions/sessionActions/createOrganization.js';
import { authSessionUser } from '@/redux/selectors/userSelectors.js';

/** Creates an organization you own and moves you into it, so you can invite your team. */
const CreateOrganizationDialog = ({ open, onOpenChange }) => {
  const dispatch = useDispatch();
  const user = useSelector(authSessionUser);
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [isCreating, setIsCreating] = useState(false);

  /* Closing clears what was typed, so the dialog opens clean next time. */
  const handleOpenChange = (next) => {
    if (!next) {
      setName('');
      setError('');
    }
    onOpenChange(next);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsCreating(true);
    const res = await dispatch(createOrganization({ name, ownerId: user?.id }));
    setIsCreating(false);

    if (res?.success === false) {
      setError(res.message === 'Company name already exists' ? 'An organization with this name already exists. Try another name.' : res.message);
      return;
    }

    toastManager.add({ type: 'success', title: `${name.trim()} created`, description: 'You are now working in it.' });
    handleOpenChange(false);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={handleOpenChange}
      title="Create an organization"
      description="Organizations share connections, knowledge and automations with the people you invite. Your personal workspace stays as it is."
      footer={
        <>
          <Button variant="ghost" onClick={() => handleOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" form="create-organization" loading={isCreating} disabled={!name.trim()}>
            Create organization
          </Button>
        </>
      }>
      <form id="create-organization" onSubmit={handleSubmit}>
        <Input label="Organization name" placeholder="Silva Furniture" value={name} onChange={(event) => setName(event.target.value)} error={error} />
      </form>
    </Dialog>
  );
};

export default CreateOrganizationDialog;
